<div class="page-sub-header">
  <div class="title-box" [class.center-filter]="options()?.control">
    <div *ngIf="customer" style="width: 100%">
      <div
        *ngIf="!isFirstLogin"
        class="flex space-between align-center"
        style="width: 100%">
        <div class="title-navigation">
          <div class="back-arrow-container" (click)="navigateBack()">
            <mat-icon svgIcon="arrow-icon" class="arrow-icon"></mat-icon>
          </div>
          <div class="title-container">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
            <h2 class="title">{{ title() }}</h2>
          </div>
          <app-resident-note
            class="resident-note"
            *ngIf="resident()?.internalNote"
            [resident]="resident()"></app-resident-note>
        </div>

        <app-toggle-filter
          *ngIf="options()?.control"
          [control]="options().control"
          [option1]="options().option1"
          [option1Icon]="options().option1Icon"
          [option2]="options().option2"
          [option2Icon]="options().option2Icon"></app-toggle-filter>
        <div *ngIf="options()?.control" class="hide-fake">
          <div class="back-arrow-container" (click)="navigateBack()">
            <mat-icon svgIcon="arrow-icon" class="arrow-icon"></mat-icon>
          </div>
          <div class="title-container">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
            <h2 class="title">{{ title() }}</h2>
          </div>
        </div>
      </div>
      <div *ngIf="isFirstLogin" class="first-login-message">
        <mat-icon
          svgIcon="first-login-arrow-icon"
          class="first-login-arrow"></mat-icon>
        <p>
          Um mit BringLiesel zu starten, legen Sie zunächst in der
          <br />
          Wohnbereichs-Verwaltung ihre Wohnbereiche und Bewohner:innen an!
        </p>
      </div>
    </div>
    <div
      *ngIf="!customer"
      style="width: 100%; height: 80%"
      class="flex justify-center align-center">
      <mat-progress-spinner
        mode="indeterminate"
        style="width: 70px"></mat-progress-spinner>
    </div>
  </div>
</div>
